module.exports = __webpack_public_path__ + "static/media/tm.ea365f33.svg";